import "./FlowTextInput.scss";
import {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useTranslation } from "react-i18next";

const FlowTextInput = forwardRef(function FlowTextInput(
  {
    placeholder,
    value,
    onChange,
    onKeyDown,
    onPaste,
    expandable = true,
    icon = "search",
    className = "",
  },
  ref,
) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(value || "");
  const inputRef = useRef(null);

  // Expose the input element to parent components via ref
  useImperativeHandle(ref, () => inputRef.current);

  useEffect(() => {
    if (value !== undefined) {
      setInputValue(value);
    }
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleClear = (e) => {
    e.preventDefault();
    setInputValue("");
    if (onChange) {
      onChange("");
    }
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div
      className={`flow-text-input-container ${className} ${!icon ? "no-icon" : ""}`}
    >
      <input
        type="text"
        placeholder={placeholder ?? t("common.searchPlaceholder")}
        className={`flow-text-input ${expandable ? "expandable" : ""}`}
        value={inputValue}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        ref={inputRef}
      />
      {icon && (
        <>
          {inputValue ? (
            <span
              className="material-symbols-outlined flow-text-input-icon"
              onMouseDown={handleClear}
              style={{ cursor: "pointer" }}
            >
              close
            </span>
          ) : (
            <span className="material-symbols-outlined flow-text-input-icon">
              {icon}
            </span>
          )}
        </>
      )}
    </div>
  );
});

export default FlowTextInput;
